import axios from "@/config/axios";

export const getWXConfig = url => axios.post("/index.php/Home/index/wx_get", {url});
